import GroupIcon from "@mui/icons-material/Group";

import { LabelValue } from "../../components/LabelValue";
import { useProductTranslation } from "../../hooks/useProductTranslation";

export type ProductMaxGroupSizeMetaDataProps = {
    maxGroupSize: string;
};

export function ProductMaxGroupSizeMetaData({ maxGroupSize }: ProductMaxGroupSizeMetaDataProps) {
    const [t] = useProductTranslation();
    const label = t("label.maxGroupSize");
    return (
        <LabelValue label={label} Icon={GroupIcon}>
            {maxGroupSize}
        </LabelValue>
    );
}
